<script>
import valuesService from '@/services/Values/valuesService';
import UpdatedValueNotification from '@/components/Notifications/Values/UpdatedValueNotification';
import UpdatedValueErrorNotification from '@/components/Notifications/Values/UpdatedValueErrorNotification';
import GetValueErrorNotification from '@/components/Notifications/Values/GetValueErrorNotification';
import {vueTopprogress} from 'vue-top-progress';

export default {
  data() {
    return {
      value: {},
      cachedValue: {},
    };
  },
  components: {
    vueTopprogress,
  },
  computed: {
    valueId() {
      return this.$route.params.id;
    },
  },
  mounted() {
    this.getValue();
  },
  methods: {
    async getValue() {
      this.$refs.topProgress.start();

      try {
        valuesService.getValue(this.valueId)
            .then(function(value) {
              this.value = value.data();
              this.cachedValue = value.data();

              this.$refs.topProgress.done();
            }.bind(this));
      } catch (error) {
        this.$notify({
          component: GetValueErrorNotification,
          icon: 'tim-icons icon-bell-55',
          horizontalAlign: 'center',
          verticalAlign: 'top',
          type: 'warning',
          timeout: 3000,
        });
      }
    },

    async updateValues() {
      this.$refs.topProgress.start();

      try {
        this.$refs.topProgress.done();

        await valuesService.updateValue(this.valueId, this.value);

        this.$router.push('/values');

        this.$notify({
          component: UpdatedValueNotification,
          icon: 'tim-icons icon-bell-55',
          horizontalAlign: 'center',
          verticalAlign: 'top',
          type: 'success',
          timeout: 3000,
        });
      } catch (error) {
        this.$notify({
          component: UpdatedValueErrorNotification,
          icon: 'tim-icons icon-bell-55',
          horizontalAlign: 'center',
          verticalAlign: 'top',
          type: 'warning',
          timeout: 3000,
        });
      }
    },
  },
};
</script>

<template>
  <div class="add-user">
    <card>
      <form @submit.prevent="updateValues()">
        <h5 slot="header" class="title">
          <router-link to="/values" class="fa fa-arrow-left"></router-link>
          Editar Valores
        </h5>

        <div class="row">
          <div class="col-md-4 pr-md-1 mb-2">
          <base-input
              label="Valor*"
              placeholder="Valor"
              v-model="value.values"
              required
            ></base-input>
          </div>
          <div class="col-md-4 pr-md-1 mb-2">
          <base-input
              label="Ordem*"
              placeholder="Ordem"
              v-model="value.order"
              required
            ></base-input>
          </div>
        </div>

        <button
          type="submit"
          class="btn btn-sm"
        >
          Editar
        </button>
      </form>
    </card>

    <vue-topprogress ref="topProgress"></vue-topprogress>
  </div>
</template>
